import axios from 'axios'
import Cookies from 'js-cookie'
import responseError from "./responseError";

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时F
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

//请求拦截器
service.interceptors.request.use(config => {
  // const token = Cookies.get('Admin-Token')
  const {noToken, url} = config // 如果想不携带token请将该值设置为true
  const token = localStorage.getItem("token")
  if (token && !noToken && !url.startsWith('https://dis.qidao123.com')) {
    config.headers['Authorization'] = 'Api_Bearer ' + token
  }
  return config
}, errors => {
  return Promise.reject(errors)
})

// 响应拦截器
service.interceptors.response.use(res => {
  const code = res.data.code || 200
  if (code !== 200) responseError.showMessage(res)
  return res.data
}, errors => {
  return Promise.reject(errors)
})

export default service